
import { Component, mixins } from 'nuxt-property-decorator';
import WebsiteHeaderMixin from './WebsiteHeaderMixin';

@Component
export default class WebsiteHeaderBoxed extends mixins(WebsiteHeaderMixin) {}
